/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UserWithNoId } from './user-with-no-id';
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Payment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Payment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    billingAddress: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    orderId: string;
    /**
     * 
     * @type {UserWithNoId}
     * @memberof Payment
     */
    userData: UserWithNoId;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    paymentStatus: PaymentPaymentStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof Payment
     */
    paymentIntent: any;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    hostedInvoiceUrl: string;
    /**
     * 
     * @type {Date}
     * @memberof Payment
     */
    invoiceDueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    refundReason: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    invoicePdf: string;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    refundAmount: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    paymentIntentId: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    chargeId: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    paymentType: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    paymentMethod: PaymentPaymentMethodEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentPaymentStatusEnum {
    Paid = 'Paid',
    Unpaid = 'Unpaid',
    Processing = 'Processing',
    PaymentFailed = 'Payment Failed',
    Cancelled = 'Cancelled',
    Refunded = 'Refunded',
    PartiallyRefunded = 'Partially Refunded',
    Disputed = 'Disputed',
    LostDispute = 'Lost Dispute'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentPaymentMethodEnum {
    Cash = 'Cash',
    Credit = 'Credit',
    Card = 'Card'
}

